export const isValidFullName = (name) => {
  return /^[A-Za-z\s]+$/.test(name.trim());
};

export const isValidAadhaarNumber = (aadhaar) => {
  return /^\d{12}$/.test(aadhaar);
};
